import { forwardRef } from "react";
import { NavLink as DefaultNavLink, NavLinkProps } from "react-router";
import { useRouting } from "./routingContext";

export interface RoutingProps extends NavLinkProps {
  disablePrefix?: boolean;
}

const Routing = forwardRef<HTMLAnchorElement, RoutingProps>((props, ref) => {
  const { to, disablePrefix, ...rest } = props;
  const { routePrefix } = useRouting();

  const newTo =
    !disablePrefix &&
    typeof to === "string" &&
    to.startsWith("/") &&
    routePrefix
      ? `${routePrefix}${to}`
      : to;

  return <DefaultNavLink to={newTo} ref={ref} {...rest} />;
});

export default Routing;
